import{defineMessages}from'react-intl';

export default defineMessages({
app_title:{
id:'i18n.app.app_title',
defaultMessage:'EVENT PORTAL'},

session_expired_warning:{
id:'i18n.app.session_expired_warning',
defaultMessage:'Your current session will be timed out in 5 minutes'},

session_expired:{
id:'i18n.app.session_expired',
defaultMessage:'Sorry session has been expired'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb250YWluZXJzL0FwcC9BcHAubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJhcHBfdGl0bGUiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwic2Vzc2lvbl9leHBpcmVkX3dhcm5pbmciLCJzZXNzaW9uX2V4cGlyZWQiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLFVBQVc7QUFDVEMsR0FBSSxvQkFESztBQUVUQyxlQUFnQixjQUZQLENBRGlCOztBQUs1QkMsd0JBQXlCO0FBQ3ZCRixHQUFJLGtDQURtQjtBQUV2QkMsZUFBZ0IscURBRk8sQ0FMRzs7QUFTNUJFLGdCQUFpQjtBQUNmSCxHQUFJLDBCQURXO0FBRWZDLGVBQWdCLGdDQUZELENBVFcsQ0FBZixDQUFmIiwiZmlsZSI6IkFwcC5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBhcHBfdGl0bGU6IHtcbiAgICBpZDogJ2kxOG4uYXBwLmFwcF90aXRsZScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdFVkVOVCBQT1JUQUwnLFxuICB9LFxuICBzZXNzaW9uX2V4cGlyZWRfd2FybmluZzoge1xuICAgIGlkOiAnaTE4bi5hcHAuc2Vzc2lvbl9leHBpcmVkX3dhcm5pbmcnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnWW91ciBjdXJyZW50IHNlc3Npb24gd2lsbCBiZSB0aW1lZCBvdXQgaW4gNSBtaW51dGVzJyxcbiAgfSxcbiAgc2Vzc2lvbl9leHBpcmVkOiB7XG4gICAgaWQ6ICdpMThuLmFwcC5zZXNzaW9uX2V4cGlyZWQnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU29ycnkgc2Vzc2lvbiBoYXMgYmVlbiBleHBpcmVkJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.messages.js
// module id = 727
// module chunks = 0